module.exports = __webpack_public_path__ + "img/hr-red-desert-decal-02.441e1e70.png";